import { Container } from "../Container/container";
import "./eightDayForecast.css";
import weather1 from "../../images/weather1.png";
import weather2 from "../../images/weather2.png";
import weather3 from "../../images/weather3.png";
import weather4 from "../../images/weather4.png";
import weather5 from "../../images/weather5.png";

export const EightDayForecast = () => {
    return (
        <section className="eightday">
            <Container>
                <div className="eightday__box">
                    <h2 className="eightday__title">8-day forecast</h2>
                    <ul className="eightday__list">
                        <li className="eightday__item">
                            <p className="eightday__desc">Fri, Mar 1</p>
                            <div className="eightday__info">
                            <img src={weather1} alt="" />
                            <p className="eightday__desc">23/14℃</p>
                            </div>
                            <p className="eightday__desc">light rain</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Sat, Mar 2</p>
                            <div className="eightday__info">
                            <img src={weather1} alt="" />
                            <p className="eightday__desc">22/10℃</p>
                            </div>
                            <p className="eightday__desc">light rain</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Sun, Mar 3</p>
                            <div className="eightday__info">
                            <img src={weather1} alt="" />
                            <p className="eightday__desc">13/6℃</p>
                            </div>
                            <p className="eightday__desc">light rain</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Mon, Mar 4</p>
                            <div className="eightday__info">
                            <img src={weather4} alt="" />
                            <p className="eightday__desc">12/4℃</p>
                            </div>
                            <p className="eightday__desc">few clouds</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Tue, Mar 5</p>
                            <div className="eightday__info">
                            <img src={weather5} alt="" />
                            <p className="eightday__desc">12/4℃</p>
                            </div>
                            <p className="eightday__desc">overcast clouds</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Wed, Mar 6</p>
                            <div className="eightday__info">
                            <img src={weather3} alt="" />
                            <p className="eightday__desc">13/3℃</p>
                            </div>
                            <p className="eightday__desc">clear sky</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Thu, Mar 7</p>
                            <div className="eightday__info">
                            <img src={weather5} alt="" />
                            <p className="eightday__desc">12/5℃</p>
                            </div>
                            <p className="eightday__desc">overcast clouds</p>
                        </li>
                        <li className="eightday__item">
                            <p className="eightday__desc">Fri, Mar 8</p>
                            <div className="eightday__info">
                            <img src={weather2} alt="" />
                            <p className="eightday__desc">9/3℃</p>
                            </div>
                            <p className="eightday__desc">scattered clouds</p>
                        </li>
                    </ul>
                </div>
        </Container>
        </section>
    )
}